export * from "./search";
export * from "./localStore";
export * from "./error";
export * from "./date";
export const emailRegEx = /^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/;
